import { Model } from '@vuex-orm/core';

export class ProductProductType extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'product_product_types';

  static primaryKey = ['product_id', 'product_type_id'];

  static fields() {
    return {
      product_id: this.attr(null),
      product_type_id: this.attr(null),
    };
  }
}

export default ProductProductType;
